export { NotificationMessage } from "./component";
export type {
  NotificationMessageProps,
  NotificationMessageSize,
  NotificationMessageStyleProps,
  NotificationMessageVariant,
} from "./types";
